import { createContext } from 'react';

import { SurveyTabsSortingContextProps } from './SurveyTabsSortingController.types';

export const SurveyTabsSortingContext = createContext<SurveyTabsSortingContextProps | null>(null);
